module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0001.jpg?v=97f6cb72";